import styled, { css } from 'styled-components';
import { statuses } from '../index';
import Button from '../../button';

export const StyledButton = styled(Button)`
  margin-bottom: 32px;

  ${({ $insideSideBar }) =>
    $insideSideBar &&
    css`
      text-align: left;
    `}

  ${({ $status }) =>
    // custom padding and font size here to accomodate long label in sidebar
    $status === statuses.LOADING &&
    css`
      padding: ${({ theme }) =>
        `20px ${theme.spacing.small} 19px ${theme.spacing.medium}`};
      h3 {
        font-size: ${({ theme }) => theme.fontsize.base};
      }
    `}
`;
